import type { PayloadAction } from "@reduxjs/toolkit";
import { DUMMY_SYSTEM_INFORMATION } from "Data/Dummy/System";
import { createAppSlice } from "Data/Redux/Store";
import type { SystemInformation } from "Interfaces";

const setSystemInformationReducer = (state: SystemInformation, action: PayloadAction<SystemInformation>) => {
	Object.assign(state, action.payload);
};

const getSystemInformation = (state: SystemInformation) => {
	return state;
};

const systemInformationSlice = createAppSlice({
	name: "information",
	initialState: DUMMY_SYSTEM_INFORMATION,
	reducers: {
		setSystemInformationAction: setSystemInformationReducer
	},
	selectors: {
		selectSystemInformation: getSystemInformation
	}
});

export default systemInformationSlice;

export const { setSystemInformationAction } = systemInformationSlice.actions;
export const { selectSystemInformation } = systemInformationSlice.selectors;
